export default __webpack_public_path__ + "static/media/player_1.da0a24f6.png";